import styles from './Tabs.module.scss';

import cx from 'classnames';
import React, { FC, ReactNode } from 'react';

import { TextV2 } from 'components/TextV2/TextV2';
import { useTabs } from './useTabs';

export type TabItem = {
  tab: string;
  tabPanel: ReactNode;
};

export type TabsProps = {
  defaultActiveIndex?: number;
  items: TabItem[];
  tablistId: string;
  variant?: 'default' | 'pill';
};

export const Tabs: FC<TabsProps> = ({ defaultActiveIndex, items, tablistId, variant = 'default' }) => {
  const { tabs, tabPanelsWrapperRef, onTransitionEnd } = useTabs({
    tablistId,
    items,
    defaultActiveIndex,
  });

  return (
    <div className={cx(styles.root, variant && styles[variant])}>
      <div>
        <div aria-labelledby={tablistId} className={cx(styles.tabList)} role="tablist">
          {tabs.map(({ tabId, tabPanelId, tab, isActive, onBlur, onClick, onFocus }) => (
            <button
              aria-controls={tabPanelId}
              aria-selected={isActive}
              className={styles.tabButton}
              id={tabId}
              key={tabId}
              role="tab"
              tabIndex={isActive ? undefined : -1}
              type="button"
              onBlur={onBlur}
              onClick={onClick}
              onFocus={onFocus}
            >
              <TextV2
                value={tab}
                variant={variant === 'pill' || isActive ? 'modern-body-medium' : 'modern-body'}
              />
            </button>
          ))}
        </div>
      </div>
      <div className={styles.tabPanelWrapper} ref={tabPanelsWrapperRef} onTransitionEnd={onTransitionEnd}>
        {tabs.map(({ tabId, tabPanelId, tabPanel }) => (
          <div
            aria-labelledby={tabId}
            className={styles.tabPanel}
            id={tabPanelId}
            key={tabPanelId}
            role="tabpanel"
          >
            {tabPanel}
          </div>
        ))}
      </div>
    </div>
  );
};
